// src/lib/fuzzy.ts — potrivire fuzzy pentru filtrul de straturi (F13-T2). Funcții PURE,
// zero dependințe: subsecvență de caractere + normalizare de diacritice (scrii „protectie"
// și găsești „Zone de protecție"). Filtrarea NU atinge harta — doar lista din sidebar.

/** Text normalizat pentru căutare: lowercase, fără diacritice (NFD + tăierea combining marks). */
export function normalize_text(s: string): string {
	return s
		.normalize("NFD")
		.replace(/[̀-ͯ]/g, "")
		.toLowerCase()
}

/**
 * Potrivire pe SUBSECVENȚĂ: toate caracterele din query apar în nume, în aceeași ordine
 * (nu neapărat consecutive) — „cnd" găsește „Conducte alimentare", „zonif" găsește
 * „Zonificare funcțională". Query gol = potrivește tot. Spațiile din query se ignoră.
 */
export function fuzzy_match(query: string, name: string): boolean {
	const q = normalize_text(query).replace(/\s+/g, "")
	if (!q) {
		return true
	}
	const n = normalize_text(name)
	let i = 0
	for (const ch of n) {
		if (ch === q[i]) {
			i++
			if (i === q.length) {
				return true
			}
		}
	}
	return false
}
